import {IssueBodyLoading} from '@github-ui/issue-body/IssueBodyLoading'
import {useContainerBreakpoint} from '@github-ui/use-container-breakpoint'
import {Box} from '@primer/styled-react'
import {type FC, useRef} from 'react'

import {ContentWrapper} from './ContentWrapper'
import {HeaderLoading} from './header/HeaderLoading'
import {IssueTimelineLoading} from './IssueTimelineLoading'
import styles from './IssueViewerLoading.module.css'
import type {OptionConfig} from './OptionConfig'
import {SidebarSectionsLoading} from './sections/SidebarSectionsLoading'

type IssueViewerLoadingProps = {
  optionConfig: Pick<OptionConfig, 'useViewportQueries'>
}

export const IssueViewerLoading: FC<IssueViewerLoadingProps> = ({optionConfig}) => {
  const issueViewerContainerRef = useRef<HTMLDivElement>(null)

  const breakpoint = useContainerBreakpoint(issueViewerContainerRef.current)
  return (
    <ContentWrapper>
      <div ref={issueViewerContainerRef} data-testid="issue-viewer-loading" className={styles.loadingContainer}>
        <div className={styles.headerLoadingWrapper}>
          <HeaderLoading />
        </div>
        <Box
          sx={{
            flexDirection: optionConfig.useViewportQueries
              ? ['column', 'column', 'row', 'row']
              : breakpoint(['column', 'column', 'row', 'row']),
          }}
          className={styles.contentAndSidebarWrapper}
        >
          <Box
            sx={{
              width: optionConfig.useViewportQueries
                ? ['100%', '100%', 'auto', 'auto']
                : breakpoint(['100%', '100%', 'auto', 'auto']),
            }}
            className={styles.contentLoadingArea}
          >
            <div>
              <IssueBodyLoading />
            </div>
            <div>
              <div className={styles.timelineLoadingWrapper}>
                <IssueTimelineLoading />
              </div>
            </div>
          </Box>

          <Box
            sx={{
              width: optionConfig.useViewportQueries
                ? ['auto', 'auto', '256px', '296px']
                : breakpoint(['auto', 'auto', '256px', '296px']),
            }}
            className={styles.sidebarLoadingArea}
          >
            <SidebarSectionsLoading />
          </Box>
        </Box>
      </div>
    </ContentWrapper>
  )
}

try{ IssueViewerLoading.displayName ||= 'IssueViewerLoading' } catch {}